import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import { ReactComponent as IconInfo } from "../Images/icon_info.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

import { useEffect, useState } from "react";

const getImageDimensions = (file) =>
  new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      resolve({
        width: image.width,
        height: image.height,
      });
      URL.revokeObjectURL(objectUrl);
    };

    image.onerror = () => {
      reject(new Error("이미지를 불러오지 못했습니다."));
      URL.revokeObjectURL(objectUrl);
    };

    image.src = objectUrl;
  });

const ImageUploadBox = ({
  title,
  info,
  handleClickX,
  pageName,
  imageUpload,
  previewImg,
  requiredDimensions = null,
}) => {
  const [previewImgUrl, setPreviewImgUrl] = useState(null);
  useEffect(() => {
    if (previewImg) {
      if (typeof previewImg === "string") {
        setPreviewImgUrl(
          previewImg.startsWith("data:") || previewImg.startsWith("blob:")
            ? previewImg
            : `${process.env.REACT_APP_IMAGE_BASE_URL}/${previewImg}`
        );
      } else {
        setPreviewImgUrl(previewImg?.map((file) => URL.createObjectURL(file)));
      }
    }
  }, [previewImg]);

  const [postImg, setPostImg] = useState(null);
  const [_previewImg, set_PreviewImg] = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const resetSelectedFile = () => {
    set_PreviewImg(null);
    setPostImg(null);
    setUploaded(false);
  };

  const handleFilePreview = async (e) => {
    let fileArr = e.target.files;
    const firstFile = fileArr?.[0];

    if (!firstFile) return;

    if (requiredDimensions) {
      try {
        const { width, height } = await getImageDimensions(firstFile);

        if (
          width !== requiredDimensions.width ||
          height !== requiredDimensions.height
        ) {
          resetSelectedFile();
          setErrorMessage(
            `이미지는 ${requiredDimensions.width}x${requiredDimensions.height}px만 업로드 가능합니다.`
          );
          e.target.value = "";
          return;
        }
      } catch (_err) {
        resetSelectedFile();
        setErrorMessage("이미지를 불러오지 못했습니다.");
        e.target.value = "";
        return;
      }
    }

    setErrorMessage("");
    setPostImg(Array.from(fileArr));

    let fileRead = new FileReader();
    fileRead.onload = function () {
      set_PreviewImg(fileRead.result);
    };

    fileRead.readAsDataURL(fileArr[0]);

    setUploaded(true);
  };

  const deleteFileUpload = () => {
    set_PreviewImg(null);
    setPreviewImgUrl(null);
    setPostImg(null);
    setUploaded(false);
    setErrorMessage("");
  };

  const inputId = `${pageName || "image-upload"}-image`;

  const handleFileUpload = () => {
    //file upload
    imageUpload(postImg);
    handleClickX();
  };

  return (
    <ModalBox>
      <div className="center">
        <p className="bold-text" style={{ fontSize: "24px" }}>
          {title}
        </p>
      </div>

      <div className="hrz-wrapper" style={{ width: "740px" }}>
        <div
          style={{
            marginLeft: "auto",
            marginTop: "-32px",
            cursor: "pointer",
          }}
        >
          <IconCrossRound onClick={handleClickX} />
        </div>
      </div>

      <div className="hrz-wrapper" style={{ marginTop: "20px" }}>
        <IconInfo width="20px" height="20px" fill="#888888" />
        <p style={{ fontSize: "15px", color: "#888888", marginLeft: "4px" }}>
          {info}
        </p>
      </div>
      {errorMessage && <p className="errorText">{errorMessage}</p>}
      {uploaded || previewImgUrl ? (
        <div className="previewBox">
          <div className="scrollBox">
            <img
              src={_previewImg ? _previewImg : previewImgUrl}
              alt="preview image"
              width="740px"
            />
          </div>
          <div className="hrz-wrapper" style={{ marginTop: "10px" }}>
            <div
              className="deleteBtn center"
              style={{ marginLeft: "auto" }}
              onClick={deleteFileUpload}
            >
              삭제
            </div>

            <div style={{ width: "8px" }} />

            <div onChange={handleFilePreview}>
              <input
                type="file"
                id={inputId}
                accept="image/*"
                style={{ display: "none" }}
              />
              <label htmlFor={inputId} className="reuploadBtn center">
                다시 업로드
              </label>
            </div>
          </div>
        </div>
      ) : (
        <div className="uploadBox center">
          <div onChange={handleFilePreview}>
            <input
              type="file"
              id={inputId}
              accept="image/*"
              style={{ display: "none" }}
            />
            <label htmlFor={inputId} className="uploadBtn center">
              이미지 업로드
            </label>
          </div>
        </div>
      )}

      <div className="hrz-wrapper center" style={{ marginTop: "20px" }}>
        <div
          className="blueBorderBtn-base center"
          style={{ width: "114px", height: "60px", borderRadius: "8px" }}
          onClick={handleClickX}
        >
          취소
        </div>
        <div style={{ width: "18px" }} />
        <div
          className="blueBtn-base center"
          style={{ width: "114px", height: "60px", borderRadius: "8px" }}
          onClick={handleFileUpload}
        >
          등록
        </div>
      </div>
    </ModalBox>
  );
};

const ImageUpload = ({
  title,
  info,
  handleClickX,
  pageName,
  imageUpload,
  previewImg = null,
  requiredDimensions = null,
}) => {
  return (
    <LayoutModal
      Modal={
        <ImageUploadBox
          title={title}
          info={info}
          handleClickX={handleClickX}
          pageName={pageName}
          imageUpload={imageUpload}
          previewImg={previewImg}
          requiredDimensions={requiredDimensions}
        />
      }
    />
  );
};

const ModalBox = styled.div`
  width: auto;
  height: auto;
  border-radius: 20px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 30px;

  .uploadBox {
    width: 740px;
    height: 496px;
    border-radius: 10px;
    margin-top: 10px;
    background-color: #f5f5f5;
  }

  .uploadBtn {
    width: 172px;
    height: 60px;
    border-radius: 8px;
    box-shadow: 0 0 0 1px #b0b0b0;
    color: #222222;
    background-color: #ffffff;
    cursor: pointer;
  }

  .errorText {
    margin-top: 8px;
    font-size: 14px;
    color: #ed4040;
  }

  .previewBox {
    width: auto;
    border-radius: 10px;

    .scrollBox {
      width: 740px;
      max-height: 496px;
      border-radius: 10px;
      overflow-x: hidden;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 6px;
        z-index: 1;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #b0b0b0;
        border-radius: 10px;
      }
    }

    margin-top: 10px;

    .deleteBtn {
      width: 46px;
      height: 36px;
      border-radius: 8px;
      background-color: #f5f5f5;
      color: #929292;
      font-family: "notoSans-medium";
      font-size: 14px;
      cursor: pointer;
    }
    .reuploadBtn {
      width: 88px;
      height: 36px;
      border-radius: 8px;
      background-color: #ffffff;
      box-shadow: inset 0 0 0 1px #b0b0b0;
      font-family: "notoSans-medium";
      font-size: 14px;
      color: #222222;
      cursor: pointer;
    }
  }
`;

export default ImageUpload;
